// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"274":"beta-terms","296":"privacy","929":"terms"}[chunkId] + "." + {"274":"ded8b7c7","296":"4fcc4055","929":"b5a3590f"}[chunkId] + ".js";
};